import React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

import { FILTERS } from './filters';
import styles from './index.styl';

export const Filters = ({ activeFilter, handleClick }) => {
  return (
    <div className={styles.root}>
      {FILTERS.map(({ type, title }) => (
        <div
          className={cn(styles.item, {
            [styles.activeItem]: type === activeFilter,
          })}
          onClick={() => handleClick(type)}
          key={type}
        >
          {title}
        </div>
      ))}
    </div>
  );
};

Filters.propTypes = {
  handleClick: PropTypes.func,
  activeFilter: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/Chart/Filters/index.jsx